import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import { Link } from "react-router-dom";

const DeliveryChargeTemplateList = () => {

  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Total Delivery Charge",
      accessorKey: "total_delivery_charge",
      cell: ({ row, getValue }: any) => (
        <>
          {getValue() ? getValue() : 0}
        </>
      ),
    },
    {
      header: "Delivery Charge",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <Link to={`/delivery-charge/${getValue()}`} >View Delivery Charge</Link>
        </>
      ),
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.DELIVERY_CHARGE_TEMPLATE}
      queryKey={"delivery-charge-template"}
      columns={defaultColumns}
      addNewPagePath={"/create-delivery-charge-template"}
      tableName={"Delivery Charge Template"}
    />
  );
};



export default DeliveryChargeTemplateList
